export type CloseType = "close"
export const Close: CloseType = "close"